import React, { useEffect, useState } from 'react';
import { Table, Select, Spin, Row, Col, message } from 'antd';
import Layouts from '../components/Layouts';
import apiRequest from '../hooks/ApiRequest';

const { Option } = Select;

const ClaimFormReport = () => {
    const [claimForms, setClaimForms] = useState([]);
    const [selectedForm, setSelectedForm] = useState(null);
    const [fields, setFields] = useState([]);
    const [reportData, setReportData] = useState([]);
    const [loading, setLoading] = useState(false);

    // 🔹 Fetch claim forms only for logged-in insurer
    const fetchClaimForms = async () => {
        try {
            setLoading(true);
            const user = JSON.parse(localStorage.getItem('user'));
            const insurerId = user?.UserId || 423; // fallback for now

            //Use your local API
            const apiUrl = process.env.REACT_APP_BASE_URL_CLAIM + `/ClaimForm/insurer/${insurerId}`;
            const res = await apiRequest(apiUrl, 'GET');
            const data = res?.data || res || [];

            setClaimForms(data);
        } catch (error) {
            console.error('Error fetching claim forms:', error);
            message.error('Failed to load claim forms.');
        } finally {
            setLoading(false);
        }
    };

    // 🔹 Fetch selected form fields
    const fetchFormFields = async (formId) => {
        try {
            setLoading(true);
            const apiUrl = process.env.REACT_APP_BASE_URL_CLAIM + `/ClaimForm/fields/${formId}`;
            const res = await apiRequest(apiUrl, 'GET');
            const data = res?.data || res || [];
            setFields(data);
        } catch (error) {
            console.error('Error fetching form fields:', error);
            message.error('Failed to fetch form fields.');
        } finally {
            setLoading(false);
        }
    };

    // 🔹 Fetch form report/submission data
    const fetchFormReportData = async (formId) => {
        try {
            setLoading(true);
            const user = JSON.parse(localStorage.getItem('user'));
            const insurerId = user?.UserId || 423;

            // Fetch all field definitions for the selected form
            const fieldApi = process.env.REACT_APP_BASE_URL_CLAIM + `/ClaimForm/fields/${formId}`;
            const fieldRes = await apiRequest(fieldApi, 'GET');
            const fields = fieldRes || []; // each has { name, fieldKey, ... }

            //  Fetch all submitted form data
            const apiUrl = process.env.REACT_APP_BASE_URL_CLAIM + `/ClaimForm/submitted/${insurerId}`;
            const res = await apiRequest(apiUrl, 'GET');
            const data = res?.data?.data || [];
            let finalReportData = [];

            //  Map submissions to readable table rows
            const parsed = data.map((item) => {
                const values = item.values || {};
                values.claimnumber = item.policyNo || '-';

                finalReportData.push(values);

            });


            debugger;

            setReportData(finalReportData);
        } catch (error) {
            console.error('❌ Error fetching form report data:', error);
            message.error('Failed to fetch claim form report.');
        } finally {
            setLoading(false);
        }
    };



    //On mount: fetch insurer-specific claim forms
    useEffect(() => {
        fetchClaimForms();
    }, []);

    // When user selects a claim form
    const handleFormSelect = (formId) => {
        setSelectedForm(formId);
        if (formId) {
            fetchFormFields(formId);
            fetchFormReportData(formId);
        } else {
            setFields([]);
            setReportData([]);
        }
    };

    // Dynamic table columns

    const columns = [

        { title: 'Claim Number', dataIndex: 'claimnumber', key: 'claimnumber' },
        ...fields.map((field) => ({
            title: field.name || field.fieldKey,
            dataIndex: field.fieldKey,
            key: field.fieldKey,
        })),
    ];

    return (
        <Layouts title="Claim Form Report" classname="dashboard">
            <Spin spinning={loading} size="large" className="loader-icon-fixed" />

            <div className="dash-bg-white">
                <Row gutter={[16, 16]} align="middle">
                    <Col xs={24} sm={12}>
                        <h3 style={{ color: '#0C1362', fontWeight: 600, fontSize: '20px' }}>
                            Claim Form Report
                        </h3>
                    </Col>

                    <Col xs={24} sm={12} style={{ textAlign: 'right' }}>
                        <Select
                            placeholder="Select Claim Form"
                            style={{ width: 300 }}
                            value={selectedForm}
                            onChange={handleFormSelect}
                            allowClear
                        >
                            {claimForms.map((form) => (
                                <Option key={form.id} value={form.id}>
                                    {form.formName || form.name || `Form #${form.id}`}
                                </Option>
                            ))}
                        </Select>
                    </Col>
                </Row>
            </div>

            <div className="table-grid-bx">
                <Table
                    columns={columns}
                    dataSource={reportData}
                    rowKey="id"
                    pagination={{ pageSize: 10 }}
                    bordered
                />
            </div>
        </Layouts>
    );
};

export default ClaimFormReport;
